import { Container, Row, Col, Modal, Button } from 'react-bootstrap'
import ModalTvc from "../tvc/ModalTvc"
import React, { useState } from 'react'

function ConfusingFrustrating (props) {

const [lgShow, setLgShow] = useState(false);

return (
<div>
	<div className="tvc__confusing">
		<Container>
			<Row>
				<Col lg={6} md={12}>
				<div className="text-left">
					<p className="tvc__confusing--shopping"><strong>Shopping for a high quality supplement can be confusing and downright frustrating.</strong></p>
					<p className="tvc__confusing--desc">There are so many brands vying for your dollar and they all say they're the best. Every purchase you make is important to you.
						<br /><br />
						<strong>You want to get the most for your money.</strong>
					</p>
				</div>
				<div className="mb-5 mt-5 text-btn-center">
					<Button variant="link" onClick={() => setLgShow(true)}>
					<a className="tvc__confusing--btn text-uppercase px-3 py-2 text-decoration-none text-white">Get the Checklist</a></Button>
				</div>
				<Modal
					size="lg"
					show={lgShow}
					onHide={() =>
					setLgShow(false)}
					aria-labelledby="example-modal-sizes-title-lg"
					>
					<ModalTvc global={props.global}/>
				</Modal>
				</Col>
				<Col lg={6} md={12}>
				<img className="tvc__confusing--woman mr-3 img-fluid" src="../images/tvc/img-shopping-for-supplement01.png" alt="Woman" /></Col>
			</Row>
		</Container>
	</div>
	<style jsx global>{`
		.btn .tvc__confusing--btn{
			font-size: 2rem!important;
			background: #FFFFFF!important;
			border: 2px solid #4575B5!important;
			color: #4575B5!important;
			border-radius: 5px!important;
			outline: none!important;
		}
		.btn .tvc__confusing--btn:hover{
			background: #4575B5!important;
			color: #FFFFFF!important;
		}
			@media(max-width: 480px){
				.btn .tvc__confusing--btn{
					font-size: 1.2rem!important;
				}
			}
		`}
	</style>
	<style jsx>{`
		.tvc__confusing{
			background: #F6FBFE;
			padding: 5rem 5rem 5rem;
		}
		.tvc__confusing--shopping{
			font-size: 1.5rem;
			line-height: 2rem;
		}
		.tvc__confusing--desc{
			font-size: 1.1rem;
			line-height: 2rem;
		}
			@media(max-width: 991px){
				.tvc__confusing{
					padding: 3rem 2rem;
				}
				.text-btn-center{
					text-align:center!important;
				}
			}
		`}
	</style>
</div>
);
}
export default ConfusingFrustrating;